import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

import './style.css'


const TerminosConmemoracion = ({ Title = true }) => {


      return (
            <Box>
                  {
                        Title
                              ?
                              <Typography variant='h1' className='textotitulo' mt={{ xs: '40px', sm: '0px' }} >
                                    Términos simplificados de Conmemoración (homenaje).
                              </Typography>
                              : <></>
                  }





                  <Typography className='textonegritas'>Publicación de Obituario y/o Homenaje y/o Conmemoración.
                  </Typography>
                  <Typography className='textobase'>
                        Reconozco que cuento con una relación directa con la persona fallecida a la quien se realizará la
                        Conmemoración (Homenaje), y con la autorización o legitimación para utilizar y subir el contenido que
                        será utilizado por Columba en la creación y publicación de dicha Conmemoración (Homenaje) en la
                        plataforma digital, de conformidad con lo regulado por la Ley de Protección Civil del Derecho al Honor,
                        a la Intimidad Personal y Familiar, y a la Propia Imagen, Ley Federal del Derecho de Autor y Ley
                        Federal de Protección de Datos Personales en Posesión de Particulares, el Código Civil Federal y
                        otros ordenamientos, de carácter nacional e internacional, aplicables al uso de imagen y datos
                        personales de personas fallecidas. Por lo anterior, otorgo mi más amplio consentimiento para que sea
                        utilizado el material compartido para la creación y publicación de la Conmemoración (Homenaje) con
                        la única finalidad de publicar un obituario, mensaje de despedida u homenaje en la plataforma digital
                        de Columba, dentro de las cuales están, de manera enunciativa más no limitativa, los siguientes:
                  </Typography>




                  <ul className='listaavisos listsizeupp'>
                        <li>
                              <Typography className='textonegritas inline'>El nombre del fallecido  </Typography>
                        </li>
                        <li>
                              <Typography className='textonegritas inline'>Fotografías del fallecido.   </Typography>
                        </li>
                        <li>
                              <Typography className='textonegritas inline'>Vídeos del fallecido.   </Typography>
                        </li>
                        <li>
                              <Typography className='textonegritas inline'>Memorias del fallecido.  </Typography>
                        </li>
                        <li>
                              <Typography className='textonegritas inline'>Datos biográficos del fallecido (básicos, como fecha de nacimiento y defunción).  </Typography>
                        </li>
                  </ul>

                  <Typography className='textobase'>
                        Asimismo, declaro y reconozco que he sido informado de la finalidad de la Conmemoración
                        (Homenaje) del uso de datos personales y contenido digital compartido, y de mi derecho de revocar
                        este consentimiento en cualquier  momento, mediante solicitud por escrito a
                        <Link href="mailto:juridico@ximagroup.com.mx"> juridico@ximagroup.com.mx</Link> o en las oficinas de Columba.
                  </Typography>



            </Box>

      );
}

export default TerminosConmemoracion;